<template>
    <tr class="table-tr-validation" :class="{'error': validationItter.error && validationItter.index == index}">
        <td style="width: 25%">
            <div class="form-group mb-0">
                <select class="form-control select-2-custom-form" 
                    disabled
                    v-model="objectRetribution.id"
                    v-select2>
                    <option value="" selected disabled>--- Pilih Kategori Retribusi ----</option>
                    <option :value="item.id" :data-name="item.name" v-for="item in dataService" :key="item.id">
                    {{item.name}}</option>
                </select>
            </div>
        </td>
        <td  style="width: 25%">
             <div class="input-group mb-2">
                <input type="text" class="form-control"
                readonly 
                v-model="objectRetribution.price"
                :disabled="loading">
                <div class="input-group-prepend" v-if="objectRetribution.unit_type">
                    <div class="input-group-text">/ {{objectRetribution.unit}}{{objectRetribution.unit_type}}</div>
                </div>
            </div>
        </td>
        <td style="width: 15%">
            <div class="form-group mb-0">
                <input class="form-control number-form text-right" type="number" min="0" placeholder="eg. Masukkan Jumlah" 
                v-model="objectRetribution.amount"
                :readonly="additionalInfo.status == 'PENDING' || additionalInfo.status == 'SUCCESS'"
                :disabled="loading">
            </div>
        </td>
        <td  style="width: 25%">
            <div class="input-group">
                <input class="form-control text-right" type="number"
                readonly
                v-model="objectRetribution.total"
                :disabled="loading">
            </div>
        </td>
    </tr>
</template>

<style>
.mx-input:disabled{
    color: #000;
}
</style>

<script>
export default {
    props: [
        'additionalInfo',
        'dataObjectRetribution',
        'dataService',
        'index',
        'loading',
        'validationItter'
    ],
    data() {
        return {
            // SET IF PRICE IS EDITABLE
            editablePrice: false,

            selectedPrice: 0,
            
            objectRetribution: {
                index: this.index,
                id: '',
                price: 0,
                amount: 1,
                unit: 1,
                unit_type: null,
                total: 0
            }
        }
    },
    computed: {
        // SET BUTTON COLOR ON DELETE BUTTON
        classButton() {
            return this.dataObjectRetribution.length > 1 ? 'btn-danger' : 'btn-info'
        },
    },
    methods: {
        // REMOVE SERVICE $EMIT
        removeService() {
            console.log(this.objectRetribution.index);
            this.$emit('handleRemove', this.objectRetribution.index)
        },
        // SET VALUE $EMIT
        setValue() {
            this.$emit('handleData', {
                index: this.objectRetribution.index,
                id: this.objectRetribution.id,
                price: parseInt(this.objectRetribution.price),
                unit: parseInt(this.objectRetribution.unit),
                unit_type: this.objectRetribution.unit_type,
                amount: parseInt(this.objectRetribution.amount),
                total: parseInt(this.objectRetribution.total)
            })
        }
    },
    watch: {
        // WATCH EVERY CHANGE ON AMOUNT
        'objectRetribution.amount': {
            handler(val){
                const self = this
                const objectRetribution = this.objectRetribution
                objectRetribution.total = function() {
                    if(objectRetribution.unit) {
                        const pricePerUnit = objectRetribution.price / objectRetribution.unit
                        return objectRetribution.amount * pricePerUnit
                    }else{
                        return objectRetribution.amount * objectRetribution.price
                    }
                }()
                this.setValue()
            }
        }
    },
    mounted() {
        const self = this

        this.objectRetribution = {
            index: this.index,
            id: this.dataObjectRetribution[this.index].id,
            price: this.dataObjectRetribution[this.index].price,
            amount: this.dataObjectRetribution[this.index].amount,
            unit: this.dataObjectRetribution[this.index].unit,
            unit_type: this.dataObjectRetribution[this.index].unit_type,
            total: this.dataObjectRetribution[this.index].total
        }

        setTimeout(() => {
            $('.select-2-custom-form').select2();
        }, 10);

        // FORCE NUMBER FORM DEFAULT VALUE TO 1
        $('.number-form').blur(function() {
            if ($(this).val() == "" || $(this).val() < 1) {
                self.objectRetribution.amount = 1
            }
        })
    }
}
</script>

<style>

</style>